import { ApiError } from "../api/client";
import { PlanLimitDetails } from "../types/billing";

function isPlanLimitDetails(value: unknown): value is PlanLimitDetails {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.metric === "string" &&
    typeof candidate.limit === "number" &&
    typeof candidate.current === "number" &&
    typeof candidate.planCode === "string"
  );
}

export function getPlanLimitDetails(error: unknown): PlanLimitDetails | null {
  if (!(error instanceof ApiError)) return null;
  if (error.status !== 402) return null;
  if (!isPlanLimitDetails(error.details)) return null;
  return error.details;
}

export function getNumericPlanLimit(limits: Record<string, unknown>, key: string): number | null {
  const raw = limits[key];
  if (raw === null || raw === undefined) return null;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0) return null;
  return parsed;
}

export function getPlanLimitLabel(metric: string) {
  if (metric === "accountsMax") return "Cuentas bancarias";
  if (metric === "cardsMax") return "Tarjetas de crédito";
  if (metric === "rulesActiveMax") return "Reglas automáticas";
  if (metric === "movementsProcessedMonthMax") return "Movimientos procesados/mes";
  return "Límite de plan";
}
